import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'
import Stats from 'components/Stats'
import Carousel from '../components/Carousel'

import contentImageUrl_the_hub from '../static/img/project-industrial_the-hub.jpg'
import contentImageUrl_ferndown from '../static/img/project-industrial_cobham.jpg'
import contentImageUrl_nowhurst from '../static/img/project-industrial_nowhurst.jpg'
import contentImageUrl_canterbury from '../static/img/project-industrial_canterbury.jpg'

const stats_the_hubb = [
  {
    label_left: "Lettable area",
    label_right: "43,000 sqft",
    bars: [
      {
        value: 96,
        max: 360
      }
    ]
  },
  {
    label_left: "Total development value (£M)",
    label_right: "12",
    bars: [
      {
        value: 45,
        max: 360
      }
    ]
  },
  {
    label_left: "Occupancy rate %",
    label_right: "20%",
    bars: [
      {
        value: 20,
        max: 100
      }
    ]
  }
]

const stats_ferndown = [
  {
    label_left: "Lettable area",
    label_right: "400,000 sqft",
    bars: [
      {
        value: 340,
        max: 360
      }
    ]
  },
  {
    label_left: "Total development value (£M)",
    label_right: "65",
    bars: [
      {
        value: 240,
        max: 360
      }
    ]
  },
  {
    label_left: "Vacancy prelet %",
    label_right: "20%",
    bars: [
      {
        value: 20,
        max: 100
      }
    ]
  }
]
const stats_nowhurst = [
  {
    label_left: "Lettable area",
    label_right: "300,000 sqft",
    bars: [
      {
        value: 260,
        max: 360
      }
    ]
  },
  {
    label_left: "Total development value (£M)",
    label_right: "70",
    bars: [
      {
        value: 250,
        max: 360
      }
    ]
  },
  {
    label_left: "Occupancy available %",
    label_right: "100%",
    bars: [
      {
        value: 100,
        max: 100
      }
    ]
  }
]
const stats_canterbury = [
  {
    label_left: "Lettable area",
    label_right: "3.5 acres",
    bars: [
      {
        value: 260,
        max: 360
      }
    ]
  },
  {
    label_left: "Total development value (£M)",
    label_right: "10-12",
    bars: [
      {
        value: 45,
        max: 360
      }
    ]
  },
  {
    label_left: "Occupancy available %",
    label_right: "100%",
    bars: [
      {
        value: 100,
        max: 100
      }
    ]
  }
]

class Industrial extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container container--layer-up">
          <Carousel
            className="carousel"
          >
            {/* PROJECT 1 */}
            <div className="layout layout--img-left">
              <div className="layout__item" style={{ backgroundImage: `url(${contentImageUrl_the_hub})`, backgroundSize: 'cover' }} />
              <div className="layout__item">
                <SectionTitle
                  align="left"
                  intro
                  icon="icon-industrial.svg"
                  title="Industrial"
                />

                <p className="copy--bold-x">The Hub Burgess Hill Sussex</p>
                <p>We engaged with MSDC the local authority in 2005/6 to consider our land being within the emerging District Plan. The Hub ultimately secured outline planning consent in 2015 for over 500,000 sqft of B1, B2 and B8 employment space. Construction of all on/off site infrastructure commenced in March 2018, the first prelet to DPD will be completed in March 2019.</p>
                <p>See <a href="http://thehubburgesshill.co.uk" target="_blank">thehubburgesshill.co.uk</a> for further info and availability</p>

                <Stats stats={stats_the_hubb} />
              </div>
            </div>

            {/* PROJECT 2 */}
            <div className="layout layout--img-left">
              <div className="layout__item" style={{ backgroundImage: `url(${contentImageUrl_ferndown})`, backgroundSize: 'cover' }} />
              <div className="layout__item">
                <SectionTitle
                  align="left"
                  intro
                  icon="icon-industrial.svg"
                  title="Industrial"
                />

                <p className="copy--bold-x">Cobham Gate Ferndown</p>
                <p>Cobham Gate is a prime employment site fronting Cobham Road within Ferndown Industrial Estate which benefits from direct access to the A31 dual carriageway (Ferndown bypass). 42,785 sq ft has been prelet to DPD which completed in 2017. Outline consent provides for 400,000 sq ft of warehouse, industrial and office uses. Speculative development of small and medium sized industrial units will commence in 2019 along with a Trade Counter scheme fronting Cobham Road</p>

                <p>See <a href="http://www.cobhamgate.com/" target="_blank">www.cobhamgate.com</a> for further information</p>

                <Stats stats={stats_ferndown} />
              </div>
            </div>

            {/* PROJECT 3 */}
            <div className="layout layout--img-left">
              <div className="layout__item" style={{ backgroundImage: `url(${contentImageUrl_nowhurst})`, backgroundSize: 'cover' }} />
              <div className="layout__item">
                <SectionTitle
                  align="left"
                  intro
                  icon="icon-industrial.svg"
                  title="Industrial"
                />

                <p className="copy--bold-x">Nowhurst Business Park</p>
                <p>Nowhurst Business Park offers the opportunity for bespoke design and build Industrial commercial property units to meet occupier business needs. With planning consent secured to provide B1(c), B2 and B8 uses, industrial/warehouse development preparatory work is in hand to provide fully serviced sites ready to match the local and regional demand.</p>

                <p>See <a href="http://www.nowhurstbusinesspark.co.uk/" target="_blank">www.nowhurstbusinesspark.co.uk</a> for further information</p>

                <Stats stats={stats_nowhurst} />
              </div>
            </div>

            {/* PROJECT 4 */}
            <div className="layout layout--img-left">
              <div className="layout__item" style={{ backgroundImage: `url(${contentImageUrl_canterbury})`, backgroundSize: 'cover' }} />
              <div className="layout__item">
                <SectionTitle
                  align="left"
                  intro
                  icon="icon-industrial.svg"
                  title="Industrial"
                />

                <p className="copy--bold-x">Canterbury Trade Park</p>
                <p>A 3.5 acre site bought unconditionally in 2006. Planning was subsequently secured for a 1 acre car showroom, a 20,000 sq ft service bay workshop or stand alone B2/B8 warehouse, circa 15,000sqft high profile Trade Counter multi unit scheme to include up to 6,000 sq ft of retail and an A3 fast food outlet.</p>

                <p>See <a href="http://www.canterburytradepark.co.uk/" target="_blank">www.canterburytradepark.co.uk</a> for further information</p>

                <Stats stats={stats_canterbury} />
              </div>
            </div>
          </Carousel>
        </div>
      </React.Fragment>
    )
  }
}

export default Industrial;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Industrial.js